import React from "react";
import { ISVG } from "./interface";

const SVG: React.FC<ISVG> = ({
  style = {},
  fill = "var(--tlx-surface-bg-surface)",
  width = 29,
  height = 31,
  className = "",
  viewBox,
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox || `0 0 ${width} ${height}`}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M14.0781 2.61485L8.07812 0.114846C7.89536 0.0390267 7.69943 0 7.50156 0C7.30369 0 7.10777 0.0390267 6.925 0.114846L0.925 2.61485C0.365625 2.8461 0 3.39297 0 3.99922C0 10.2023 3.57812 14.4898 6.92188 15.8836C7.29063 16.0367 7.70625 16.0367 8.075 15.8836C10.7531 14.768 15 10.9148 15 3.99922C15 3.39297 14.6344 2.8461 14.0781 2.61485ZM7.69375 14.9617C7.56875 15.0117 7.43125 15.0117 7.30937 14.9617C4.25 13.7492 1 9.49922 1 3.99922C1 3.7961 1.12187 3.61485 1.30625 3.53672L7.30625 1.03672C7.42812 0.986721 7.56875 0.986721 7.69063 1.03672L13.6906 3.53672C13.8781 3.61485 14 3.7961 13.9969 3.99922C14 9.49922 10.75 13.7492 7.69375 14.9617ZM7.5 12.843V3.12422L3.04063 4.9836C3.35625 8.73672 5.45 11.7023 7.5 12.843ZM6.5 10.7555C5.3625 9.5086 4.44375 7.69922 4.12187 5.61485L6.5 4.62422V10.7555Z"
      fill={fill}
    />
  </svg>
);

export default SVG;
